import { defineMessages } from 'react-intl-next';

export const i18n: {
	filterTypePlaceholder: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	type: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	type: {
		id: 'dynamic-cards-search-page.filters.names.type',
		defaultMessage: 'Type',
		description:
			'Label for type filter dropdown shown in search page filters where user can select type to filter search result by content type such page and blog posts',
	},
	filterTypePlaceholder: {
		id: 'dynamic-cards-search-page.filter.type.placeholder',
		defaultMessage: 'Find type',
		description: 'Placeholder for type filter search input',
	},
});
